import React from 'react';
import styles from '../css/comuns/Quemsomos.module.css';
import { config } from '../../data';

const Quemsomos = () => {
  const texts = config.texts.quemSomos;
  const image = config.images.quemSomos.img;

  return (
    <section className={styles.secaoPrincipal}>
      <div className={styles.container}>
        <div className={styles.conteudoPrincipal}>
          {/* Texto */}
          <div className={styles.textoContainer}>
            <h1 className={styles.tituloPrincipal}>{texts.titulo} <br /> {texts.subtitulo}</h1>
            <p className={styles.descricaoPrincipal}>
              {texts.paragrafo1}
            </p>
            <p className={styles.descricaoPrincipal}>
              {texts.paragrafo2}
            </p>
            <button className={styles.botaoAcao}>{texts.botao}</button>
          </div>
          {/* Imagem */}
          <div className={styles.wrapperImagem}>
            <img src={image} alt="Equipe da Oni Telecom com notebook" />
          </div>
        </div>

        {/* Informações adicionais */}
        <div className={styles.secaoInfo}>
          <div className={styles.infoContainer}>
            <div className={styles.infoBox}>
              <h3>{texts.oferecemos.titulo}</h3>
              <ul>
                {texts.oferecemos.items.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
            <div className={styles.infoBox}>
              <h3>{texts.diferenciais.titulo}</h3>
              <ul>
                {texts.diferenciais.items.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Quemsomos;